export const LOGIN_PATH = "/";
export const RESET_PASSWORD_PATH = "/reset-password";
export const DASHBOARD_PATH = "/dashboard";
export const QUESTIONS_PATH = "/questions";
export const Leadcaremanager_PATH = "/careManager";
export const OutreachLeaders_PATH = "/outreachLeaders";
export const OutreachStaff_PATH = "/outreachStaff";
export const ReferralCoordinator_PATH = "/referralcoordinator";
export const Members_PATH = "/members";
export const POLICIES_PATH = "/policies";
export const COMMUNITY_OUTREACH_PATH = "/community-outreach";
export const SURVEY_HISTORIES_PATH = "/survey-history";
export const SURVEY_HISTORY_PATH = "/members/:id";
export const REFERRAL_HISTORY_PATH = "/referrals/:id";
export const START_ENCOUNTERS_PATH = "/community-outreach/:user/:id";
export const ENCOUNTERS_HISTORY_PATH = "/community-outreach/:user";

export const SURVEY_PATH = "/survey/:id";
export const RELEASE_PATH = "/releases";
export const SPA_PATH = "/spa";
export const RELEASE_DETAIL_PATH = "/releases/:id";
export const REFERRALS_PATH = "/referrals";
export const USERS_PATH = "/users";
export const TEMPLATES_PATH = "/templates";
